export enum ShippingMethodId {
    ONLY_FOR_CLASSES_AND_EGC = 'onlyForClassesAndEGC',
    BOPIS = 'PickupInStore',
    SAME_DAY_DELIVERY = 'same-day-delivery',
    OVERNIGHT = 'overnight',
    EXPRESS = 'express',
    STANDARD = 'standard',
    STANDARD_AK_HI = 'standard-AK-HI',
    STANDARD_APO_FPO = 'standard-APO-FPO',
}
